import CircularButton from "@/components/CircularButton";
import CircularProgress from "@/components/CircularProgress";
import { iconSizes } from "@/utils/iconProps";
import { themeColors } from "@/utils/themeColors";
import { ArrowDown } from "lucide-react";

const ScrollToTopFab = ({ onScroll, style }: { onScroll: () => void; style?: React.CSSProperties }) => {
    return (
        <CircularButton
            tabIndex={-1}
            radius={"6rem"}
            onClick={onScroll}
            tooltip={"Scroll to bottom"}
            style={{
                cursor: "pointer",
                zIndex: 1500,
                backgroundColor: themeColors.neutralWhite,
                boxShadow: `0px 2px 15px 5px rgb(0, 0, 0, 0.08)`,
                ...style,
            }}>
            <CircularProgress
                value={0}
                size={"6rem"}
                thickness={3}
                bgColor={themeColors.neutralWhite}
                color="#50d2c2"
                disableAnimation
                label={<ArrowDown size={iconSizes.MD} color={themeColors.neutralBlack} />}
            />
        </CircularButton>
    );
};

export default ScrollToTopFab;
